<template>
  <v-card outlined rounded="lg" :loading="loading" class="pa-3 h-100">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-map-marker-radius</v-icon>
      ที่ตั้งสถานศึกษา (จังหวัด)
    </div>
    <div id="chartdiv"></div>
  </v-card>
</template>

<script>
// แผนที่ประเทศไทย เน้นจังหวัดที่ตั้งของสถานศึกษา — เดิมคำนวณ province_ID จากการตัด substring
// ของรหัสวิทยาลัย (college_code) เอาเอง (เลขหลักที่ 3-4 ของรหัสบังเอิญตรงกับรหัสจังหวัด) ซึ่งเปราะบาง
// ตอนนี้รับ province-id จาก parent โดยตรง (parent อ่านมาจาก collegeinfo.php ที่มีคอลัมน์ province_ID
// อยู่แล้ว) — ยังคง fallback เป็นวิธีเดิมไว้เผื่อ parent ยังไม่โหลดข้อมูลมาทัน
export default {
  name: "DashboardOvecMasterMapThaigis",
  props: {
    provinceId: { type: [String, Number], default: null }
  },

  data() {
    return {
      ApiKey: "HRvec2021",
      loading: false,
      areas: []
    };
  },

  async mounted() {
    await this.fetchstdProvinceid();
  },

  watch: {
    provinceId(val) {
      if (val) this.fetchstdProvinceid();
    }
  },

  methods: {
    async fetchstdProvinceid() {
      const pid = this.provinceId || this.fallbackProvinceId;
      if (!pid) return;
      this.loading = true;
      let result = await this.$http
        .post("province_sh.php", { ApiKey: this.ApiKey, province_ID: pid })
        .finally(() => (this.loading = false));

      let data = result.data;
      if (!data || !data.province_ID) return;

      this.areas = [
        { id: "TH-" + data.province_ID, title: data.province_name, value: data.countcollege }
      ];
      this.mapThai();
    },

    mapThai() {
      var map = AmCharts.makeChart("chartdiv", {
        type: "map",
        theme: "light",
        colorSteps: 10,
        hideCredits: true,
        dataProvider: { map: "thailandLow", areas: this.areas },
        areasSettings: {
          autoZoom: true,
          rollOverOutlineColor: "#FFFFFF",
          rollOverColor: "#B3151B",
          alpha: 0.8,
          unlistedAreasAlpha: 0.1,
          balloonText: "[[title]] [[value]] วิทยาลัย"
        },
        export: { enabled: false }
      });
    }
  },

  computed: {
    fallbackProvinceId() {
      let newItems = String(this.$route.query.college_ID);
      return newItems.slice(2, 4);
    }
  }
};
</script>

<style scoped>
.h-100 {
  height: 100%;
}
.section-card-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
#chartdiv {
  width: 100%;
  height: 340px;
}
</style>
